module.exports = __webpack_public_path__ + "img/wechathelp.9a497b31.png";